import React from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa';

const RatingStars = ({
  value = 0,
  onChange,
  readOnly = false,
}) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((star) => {
          const active = star <= value;

          return (
            <button
              key={star}
              type="button"
              disabled={readOnly}
              onClick={() => !readOnly && onChange?.(star)}
              className={`transition-transform ${
                readOnly ? 'cursor-default' : 'hover:scale-110'
              }`}
            >
              {active ? (
                <FaStar className="text-2xl text-yellow-500" />
              ) : (
                <FaRegStar className="text-2xl text-gray-700" />
              )}
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-5 text-xs text-gray-700">
        {[1, 2, 3, 4, 5].map((n) => (
          <span key={n} className="w-4 text-center">
            {n}
          </span>
        ))}
      </div>
    </div>
  );
};

export default RatingStars;
